import { BellSlashIcon } from '@heroicons/react/24/outline';
import { Avatar, Badge, Table } from 'react-daisyui';
import { useModalsContext } from '../../../providers/ModalsProvider/Modals.context';
import {
  eChannelType,
  eLeadStatus,
} from '../../../providers/SocketsProvider/Sockets.enums';
import { useWorkspaceContext } from '../../../providers/WorkspaceProvider/Workspace.context';
import { GetInitialsName } from '../../../utils/GetInitialsName';
import useOpenLeadChat from '../../ChatModal/useOpenLeadChat.hook';
import { integrationIcons } from '../AdvanceSearchModal.constants';
import { tTableRowProps } from '../AdvanceSearchModal.types';
import StatusEmoji from './StatusEmoji.component';
import { useACLContext } from 'src/providers/ACLProvider/ACL.hook.ts';

export default function TableRow(props: tTableRowProps) {
  const { lead, innerRef } = props;
  const { setAdvanceSearchModalIsOpen } = useModalsContext();
  const openLeadChat = useOpenLeadChat();
  const { workspaceInfo, getDisplayIntegration } = useWorkspaceContext();
  const { canUserAccessWhatsAppApi } = useACLContext();
  const defaultChannel = canUserAccessWhatsAppApi()
    ? eChannelType.WHATSAPP_API
    : eChannelType.WHATSAPP_WEB;

  function handleRowClick() {
    if (!lead.id) return;
    setAdvanceSearchModalIsOpen(false);
    // Every route, archived leads included: reading their history is the point (AGI-761).
    openLeadChat(lead);
  }

  return (
    <Table.Row
      onClick={handleRowClick}
      className="AdvanceSearchModal__Body__Table__Row"
    >
      <span className="flex items-center gap-2">
        <span className="w-[1.125rem]">
          <StatusEmoji status={lead?.status?.name ?? eLeadStatus.NEUTRAL} />
        </span>
        <div ref={innerRef} className="relative">
          <Avatar
            color="primary"
            size="xs"
            shape="circle"
            letters={GetInitialsName(lead.name)}
            src={lead.profilePicture || undefined}
          />
          <img
            className="w-5 h-5 absolute -bottom-1 -right-1"
            src={
              integrationIcons[
                getDisplayIntegration(
                  lead?.chat?.integration || defaultChannel,
                  defaultChannel,
                )
              ]
            }
          />
        </div>
      </span>
      <span className="form-control">
        <p className="font-sans font-bold w-36 truncate">{lead.name}</p>
        {!lead.active ? (
          <div className="flex items-center gap-1">
            <BellSlashIcon className="w-4" />{' '}
            <Badge size="sm" color="neutral">
              Archivado
            </Badge>
          </div>
        ) : null}
      </span>
      <span>{lead.funnel?.name}</span>
      <span>{lead.stage?.name}</span>
      <span>
        {lead.assignedUser?.authID &&
        workspaceInfo?.users?.[lead.assignedUser.authID]?.name
          ? workspaceInfo.users[lead.assignedUser.authID].name
          : 'No asignado'}
      </span>
    </Table.Row>
  );
}
